import { useQueryClient } from '@tanstack/react-query';

import { useQuery } from '@hooks/reactQuery';

import { getActiveAlarms } from '@api/alarmHistory';

import { extractQueryParams } from '@utils/common';
import { formatDate } from '@utils/date';

import { IAlarmInformation } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';

import { EAlarmStatus } from '@enums/alarms';
import { EVendorsValues } from '@enums/common';

import { formatTemplateDefault } from '@constants/common';
import { ACTIVE_ALARMS } from '@constants/queryKeys';

interface IUseQueryActiveAlarmsListOranReturn {
	data: IAlarmInformation[];
	countOfRecords: number;
	isLoading: boolean;
	invalidateQuery: () => void;
}

export const useQueryActiveAlarms = (params: IAlarmByVendor): IUseQueryActiveAlarmsListOranReturn => {
	const queryClient = useQueryClient();

	const { fromDate, toDate, vendor } = params;

	const isEnabled = vendor === EVendorsValues.limenet;
	const { isEnabled: isEnabledTab, ...restParams } = params;

	const dto = {
		...restParams,
		status: EAlarmStatus.active,
		fromText: fromDate ? formatDate(fromDate, formatTemplateDefault) : null,
		toText: toDate ? formatDate(toDate, formatTemplateDefault) : null,
		vendor: undefined,
	};

	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ACTIVE_ALARMS, dto],
		queryFn: extractQueryParams(getActiveAlarms),
		enabled: [isEnabled, isEnabledTab],
		refetchOnWindowFocus: false,
	});

	const invalidateQuery = () => {
		return [queryClient.invalidateQueries([ACTIVE_ALARMS])];
	};

	return {
		data: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoading: isInitialLoading,
		invalidateQuery,
	};
};
